/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_Caption_Style_All_HelpInputs */

const en_apply_caption_style_all_help = /** @type {(inputs: Apply_Caption_Style_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update the caption style of all events in the selected event group`)
};

const fr_apply_caption_style_all_help = /** @type {(inputs: Apply_Caption_Style_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour le style de tous les événements du groupe sélectionné`)
};

const de_apply_caption_style_all_help = /** @type {(inputs: Apply_Caption_Style_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisieren Sie den Beschriftungsstil aller Ereignisse in der ausgewählten Ereignisgruppe.`)
};

const it_apply_caption_style_all_help = /** @type {(inputs: Apply_Caption_Style_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna lo stile della didascalia di tutti gli eventi nel gruppo di eventi selezionato`)
};

const ru_apply_caption_style_all_help = /** @type {(inputs: Apply_Caption_Style_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить стиль подписей всех событий в выбранной группе событий.`)
};

const es_apply_caption_style_all_help = /** @type {(inputs: Apply_Caption_Style_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar el estilo de subtítulo de todos los eventos en el grupo de eventos seleccionado`)
};

const zh_cn2_apply_caption_style_all_help = /** @type {(inputs: Apply_Caption_Style_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新所选事件组中所有事件的标题样式`)
};

const ja_apply_caption_style_all_help = /** @type {(inputs: Apply_Caption_Style_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベント グループ内のすべてのイベントのキャプション スタイルを更新します`)
};

const hi_apply_caption_style_all_help = /** @type {(inputs: Apply_Caption_Style_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित इवेंट समूह में सभी इवेंट्स के कैप्शन स्टाइल को अपडेट करें`)
};

const pt_pt2_apply_caption_style_all_help = /** @type {(inputs: Apply_Caption_Style_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualize o estilo da legenda de todos os eventos no grupo de eventos selecionado.`)
};

/**
* | output |
* | --- |
* | "Update the caption style of all events in the selected event group" |
*
* @param {Apply_Caption_Style_All_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply_caption_style_all_help = /** @type {((inputs?: Apply_Caption_Style_All_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_Caption_Style_All_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_apply_caption_style_all_help(inputs)
	if (locale === "de") return de_apply_caption_style_all_help(inputs)
	if (locale === "it") return it_apply_caption_style_all_help(inputs)
	if (locale === "ru") return ru_apply_caption_style_all_help(inputs)
	if (locale === "es") return es_apply_caption_style_all_help(inputs)
	if (locale === "zh-CN") return zh_cn2_apply_caption_style_all_help(inputs)
	if (locale === "ja") return ja_apply_caption_style_all_help(inputs)
	if (locale === "hi") return hi_apply_caption_style_all_help(inputs)
	if (locale === "pt-PT") return pt_pt2_apply_caption_style_all_help(inputs)
	return en_apply_caption_style_all_help(inputs)
});